import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Card } from 'material-ui/Card'
import { Table, TableHeader, TableBody } from 'material-ui/Table'

import ApptTypesTableHeader from './ApptTypesTableHeader'
import ApptTypesTableRow from './ApptTypesTableRow'
import ConfirmationPopOver from './ConfirmationPopOver'

class ApptTypesTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      confirmPopOverType: {},
    }
  }

  preventDefaultUpdate = (updatedVisibility, apptType, updatedWindow) => {
    const { id, post_nv_window: window, visibility } = apptType
    if (updatedVisibility !== visibility) {
      if (updatedVisibility === 'new') {
        this.setState({
          confirmPopOverType: apptType,
        })
      } else {
        this.updateAppointmentType(updatedVisibility, id, window)
      }
    } else if (updatedWindow !== window) {
      this.updateAppointmentType(visibility, id, updatedWindow)
    }
  }

  closePopOver = () => {
    this.setState({
      confirmPopOverType: {},
    })
  }

  updateAppointmentType = (updatedVisibility, apptTypeId, window) => {
    const { patchAppointmentType } = this.props
    patchAppointmentType(apptTypeId, updatedVisibility, window)
    this.closePopOver()
  }

  render() {
    const { confirmPopOverType } = this.state
    const { appointmentTypes, hasPatientPortal } = this.props
    return (
      <div>
        <ConfirmationPopOver
          updateAppointmentType={this.updateAppointmentType}
          confirmPopOverType={confirmPopOverType}
          closePopOver={this.closePopOver}
        />
        <h2>All Appointment Types</h2>
        <Card expandable={false}>
          <Table fixedHeader>
            <TableHeader displaySelectAll={false}>
              <ApptTypesTableHeader hasPatientPortal={hasPatientPortal} />
            </TableHeader>
            <TableBody displayRowCheckbox={false} stripedRows>
              {appointmentTypes.map(appointmentType => (
                <ApptTypesTableRow
                  key={appointmentType.id}
                  appointmentType={appointmentType}
                  hasPatientPortal={hasPatientPortal}
                  preventDefaultUpdate={this.preventDefaultUpdate}
                />
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    )
  }
}

ApptTypesTable.propTypes = {
  appointmentTypes: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      visibility: PropTypes.string,
    }),
  ),
  patchAppointmentType: PropTypes.func.isRequired,
  hasPatientPortal: PropTypes.bool.isRequired,
}

export default ApptTypesTable



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/ApptTypesTable.js